import React from 'react';
import {Redirect} from 'react-router-dom';
import {observer} from 'mobx-react';
import {withStore} from '../../hocs';
import {EnumUserType} from '../../enum/EnumUserType';

// @ts-ignore
@withStore
@observer
export class AdminPanelRouteGuard extends React.Component {
    render() {
        // @ts-ignore
        const {store, children} = this.props;
        const {isAuth, user} = store?.mainStore;
        if (!isAuth) {
            return <Redirect to="/login"/>;
        }
        const t = user?.type;
        if (t !== EnumUserType.adminAuth && t !== EnumUserType.root) {
            return <Redirect to="/personal"/>;
        }
        return <>{children}</>;
    }
}
